import { format } from "date-fns";
import { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Button } from "rsuite";
import { useLapsedPolicies } from "../../redux/store/lapsedPolicies";
// import { PrinterOutlined } from '@ant-design/icons';
import { faPrint, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { HideLoader, ShowLoader } from "../../utils/helper";

const RevivedPolicyDetail = () => {
  const { policyNo } = useParams();
  const detailRef = useRef<HTMLDivElement>(null);

  const { get_RevivedPolicyById, revivedPolicyDetail } = useLapsedPolicies();
  const [isChildProduct, setIsChildProduct] = useState(false);

  useEffect(() => {
    const fetchPolicyDetail = async () => {
      if (policyNo) {
        ShowLoader();
        await get_RevivedPolicyById(policyNo);
        HideLoader();
      }
    };
    fetchPolicyDetail();
  }, []);

  useEffect(() => {
    const productName = revivedPolicyDetail?.productName;
    setIsChildProduct(Boolean(productName && productName.includes("Child ")));
  }, [revivedPolicyDetail]);

  if (!policyNo) {
    return (
      <div className="p-6 text-center text-gray-600">Policy not found.</div>
    );
  }

  const isLastFemale = (value: string | string[] | undefined): boolean => {
    if (!value) return false; // handle undefined/null
    return value.split("|").pop()?.trim().toUpperCase() === "FEMALE";
  };

  const handlePrintSection = () => {
    const printContent = document.getElementById("printArea").innerHTML;
    const originalContent = document.body.innerHTML;

    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
    window.location.reload(); // reload to restore React state
  };

  return (
    <>
      <div className="text-end">
        <Button
          startIcon={<FontAwesomeIcon icon={faPrint} />}
          appearance="primary"
          className="btn-primary mb-3"
          onClick={handlePrintSection}
        >
          Print
        </Button>
      </div>

      <div
        className="shadow bg-white rounded-lg p-4 mb-3 print-section"
        id="printArea"
      >
        <h2 className="font-semibold text-xl mb-3">Insured details</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-4 mb-4">
          <div>
            <div className="mb-0">
              Insured Name {isChildProduct && "| Proposer Name"}
            </div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.insuredName}
            </div>
          </div>

          <div>
            <div className="">
              {isChildProduct ? "Insured Gender | Proposer Gender" : "Gender"}
            </div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.gender}
            </div>
          </div>

          <div>
            <div className="">Term</div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.term}
            </div>
          </div>

          <div>
            <div className="">Pay Term</div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.payTerm}
            </div>
          </div>

          <div>
            <div className="">DOC</div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.doc
                ? format(new Date(revivedPolicyDetail?.doc), "yyyy-MM-dd")
                : ""}
            </div>
          </div>

          <div>
            <div className="">Maturity Date</div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.maturityDate
                ? format(
                    new Date(revivedPolicyDetail?.maturityDate),
                    "yyyy-MM-dd"
                  )
                : ""}
            </div>
          </div>

          <div>
            <div className="">Next Due Date</div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.nextDueDate
                ? format(
                    new Date(revivedPolicyDetail?.nextDueDate),
                    "yyyy-MM-dd"
                  )
                : ""}
            </div>
          </div>

          <div>
            <div className="">Date of Revival</div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.createdDate
                ? format(
                    new Date(revivedPolicyDetail?.createdDate),
                    "yyyy-MM-dd"
                  )
                : ""}
            </div>
          </div>

          <div>
            <div className="">Policy No</div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.policyNo}
            </div>
          </div>

          <div>
            <div className="">DIA</div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.mobile}
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="">Product Name</div>
            <div className="font-semibold mb-2">
              {revivedPolicyDetail?.productName}
            </div>
          </div>

          <div className="md:col-span-3 xl:col-span-4">
            <h4 className="text-xl font-semibold text-center underline mb-4">
              विषयः जीवन बीमालेख पुनर्जागरण गराइदिने बारे ।
            </h4>

            <div className="text-justify leading-relaxed">
              उपरोक्त सम्बन्धमा मेरो / बीमा चाहने व्यक्तिको जीवन बीमालेखमा
              भुक्तानी गर्नुपर्ने नविकरण बीमाशुल्क विभिन्न कारणले तोकिएको समयमा
              भुक्तान गर्न नसकिएकाले बीमालेख व्यतित भएको छ। अतः सो व्यतित
              बीमालेख कम्पनीको नियमानुसार पुनर्जागरण गरिदिनुहुन अनुरोध गर्दछु।
            </div>
          </div>
          <div className="md:col-span-3 xl:col-span-4 bg-gray-50 border-dashed border-2 p-4 rounded-lg">
            <div className="grid grid-cols-1 gap-3">
              <div className="col-span-4">
                <div className="">
                  १. (क) तपाईको {isChildProduct ? "बच्चाको" : ""} उचाइ कति छ ?
                </div>
                <div className="font-semibold ml-5">
                  {revivedPolicyDetail?.insuredMedical?.height}
                </div>
              </div>

              <div className="col-span-4">
                <div className="">
                  १. (ख) तपाईको {isChildProduct ? "बच्चाको" : ""} वजन कति छ ?
                </div>
                <div className="font-semibold ml-5">
                  {revivedPolicyDetail?.insuredMedical?.weight}
                </div>
              </div>

              <div className="col-span-4">
                <div>
                  २. तिन वर्ष यता{" "}
                  {isChildProduct ? "तपाईको बच्चलाई" : "तपाईलाई"} एक हप्ता अवधि
                  सम्म रहने कुनै रोग लागेको थियो ?
                </div>
                <div className="font-semibold ml-5">
                  {revivedPolicyDetail?.insuredMedical?.hasDisease === "True"
                    ? "थियो"
                    : "थिएन"}
                </div>
              </div>

              <div className="col-span-4">
                <div>
                  ३. तिन वर्ष यता {isChildProduct ? "तपाईको बच्चको" : "तपाईले"}{" "}
                  कुनै शल्यक्रिया, दुर्घटना तथा सख्त घाईते, चोटपटक, कुनै अंग भंग
                  भएको वा काटी फालेको समेत तथा रोग तथा चोट पटकको कारणले अस्पताल
                  भर्ना भएको वा औषधी उपचार गरिएको थियो ?
                </div>
                <div className="font-semibold ml-5">
                  {revivedPolicyDetail?.insuredMedical?.hasSurgery === "True"
                    ? "थियो"
                    : "थिएन"}
                </div>
              </div>

              <div className="col-span-4">
                <div>
                  ४. हाल {isChildProduct ? "तपाईको बच्चा" : "तपाई"} कोभिड—१९ को
                  संक्रमणबाट ग्रसित {isChildProduct ? "छ" : "हुनुहुन्छ"} ?
                </div>
                <div className="font-semibold ml-5">
                  {revivedPolicyDetail?.insuredMedical?.hasCovid === "True"
                    ? "छ"
                    : "छैन"}
                </div>
              </div>

              <div className="col-span-4">
                <div>
                  ५. {isChildProduct ? "तपाईको बच्चा" : "तपाई"} अहिले पूर्ण
                  स्वास्थ हुनुहुन्छ ?
                </div>
                <div className="font-semibold ml-5">
                  {revivedPolicyDetail?.insuredMedical?.isHealthy === "True"
                    ? "छ"
                    : "छैन"}
                </div>
              </div>

              {revivedPolicyDetail?.gender == "FEMALE" && !isChildProduct && (
                <>
                  <div className="col-span-4">
                    <div>६. (क) के तपाई गर्भवती हुनुहुन्छ ?</div>
                    <div className="font-semibold ml-5">
                      {revivedPolicyDetail?.insuredMedical?.isPregnant ===
                      "True"
                        ? "छ"
                        : "छैन"}
                    </div>
                  </div>

                  <div className="col-span-4">
                    <div>
                      ६. (ख) गर्भपतन वा अन्य किसिमको असामान्य प्रसुति गर्नु भएको
                      छ ?
                    </div>
                    <div className="font-semibold ml-5">
                      {revivedPolicyDetail?.insuredMedical?.hasAbortion ===
                      "True"
                        ? "छ"
                        : "छैन"}
                    </div>
                  </div>

                  {revivedPolicyDetail?.insuredMedical?.hasAbortion ===
                    "True" && (
                    <div className="col-span-4">
                      <div>६. (ख) गर्भपतनको मिति के हो ?</div>
                      <div className="font-semibold ml-5">
                        {revivedPolicyDetail?.insuredMedical?.dateOfAbortion
                          ? format(
                              new Date(
                                revivedPolicyDetail?.insuredMedical?.dateOfAbortion
                              ),
                              "yyyy-MM-dd"
                            )
                          : ""}
                      </div>
                    </div>
                  )}

                  <div className="col-span-4">
                    <div>६. (ग) के तपाईका छोराछोरी छन् ?</div>
                    <div className="font-semibold ml-5">
                      {revivedPolicyDetail?.insuredMedical?.hasChildren ===
                      "True"
                        ? "छ"
                        : "छैन"}
                    </div>
                  </div>

                  {revivedPolicyDetail?.insuredMedical?.hasChildren ===
                    "True" && (
                    <>
                      <div className="col-span-4">
                        <div>६. (ग) अन्तिम प्रसूतिको तरिका के थियो ?</div>
                        <div className="font-semibold ml-5">
                          {revivedPolicyDetail?.insuredMedical?.deliveryType}
                        </div>
                      </div>
                      <div className="col-span-4">
                        <div>६. (ग) प्रसूति भएको मिति के हो ?</div>
                        <div className="font-semibold ml-5">
                          {revivedPolicyDetail?.insuredMedical?.dateOfPregnancy
                            ? format(
                                new Date(
                                  revivedPolicyDetail?.insuredMedical?.dateOfPregnancy
                                ),
                                "yyyy-MM-dd"
                              )
                            : ""}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>

        {/* <hr /> */}

        {isChildProduct && (
          <>
            <h2 className="font-semibold text-xl my-3">Proposer details</h2>
            <div className="col-span-4 bg-gray-50 border-dashed border-2 p-4 rounded-lg">
              <div className="grid grid-cols-1 gap-3">
                <div className="col-span-4">
                  <div className="">१. (क) तपाईको उचाइ कति छ ?</div>
                  <div className="font-semibold ml-5">
                    {revivedPolicyDetail?.proposerMedical?.height}
                  </div>
                </div>

                <div className="col-span-4">
                  <div className="">१. (ख) तपाईको वजन कति छ ?</div>
                  <div className="font-semibold ml-5">
                    {revivedPolicyDetail?.proposerMedical?.weight}
                  </div>
                </div>

                <div className="col-span-4">
                  <div>
                    २. तिन वर्ष यता तपाईलाई एक हप्ता अवधि सम्म रहने कुनै रोग
                    लागेको थियो ?
                  </div>
                  <div className="font-semibold ml-5">
                    {revivedPolicyDetail?.proposerMedical?.hasDisease === "True"
                      ? "थियो"
                      : "थिएन"}
                  </div>
                </div>

                <div className="col-span-4">
                  <div>
                    ३. तिन वर्ष यता तपाईले कुनै शल्यक्रिया, दुर्घटना तथा सख्त
                    घाईते, चोटपटक, कुनै अंग भंग भएको वा काटी फालेको समेत तथा रोग
                    तथा चोट पटकको कारणले अस्पताल भर्ना भएको वा औषधी उपचार गरिएको
                    थियो ?
                  </div>
                  <div className="font-semibold ml-5">
                    {revivedPolicyDetail?.proposerMedical?.hasSurgery === "True"
                      ? "थियो"
                      : "थिएन"}
                  </div>
                </div>

                <div className="col-span-4">
                  <div>
                    ४. हाल तपाई कोभिड—१९ को संक्रमणबाट ग्रसित हुनुहुन्छ ?
                  </div>
                  <div className="font-semibold ml-5">
                    {revivedPolicyDetail?.proposerMedical?.hasCovid === "True"
                      ? "छ"
                      : "छैन"}
                  </div>
                </div>

                <div className="col-span-4">
                  <div>५. तपाई अहिले पूर्ण स्वास्थ हुनुहुन्छ ?</div>
                  <div className="font-semibold ml-5">
                    {revivedPolicyDetail?.proposerMedical?.isHealthy === "True"
                      ? "छ"
                      : "छैन"}
                  </div>
                </div>

                {isLastFemale(revivedPolicyDetail?.gender) && (
                  <>
                    <div className="col-span-4">
                      <div>६. (क) के तपाई गर्भवती हुनुहुन्छ ?</div>
                      <div className="font-semibold ml-5">
                        {revivedPolicyDetail?.proposerMedical?.isPregnant ===
                        "True"
                          ? "छ"
                          : "छैन"}
                      </div>
                    </div>

                    <div className="col-span-4">
                      <div>
                        ६. (ख) गर्भपतन वा अन्य किसिमको असामान्य प्रसुति गर्नु
                        भएको छ ?
                      </div>
                      <div className="font-semibold ml-5">
                        {revivedPolicyDetail?.proposerMedical?.hasAbortion ===
                        "True"
                          ? "छ"
                          : "छैन"}
                      </div>
                    </div>

                    {revivedPolicyDetail?.proposerMedical?.hasAbortion ===
                      "True" && (
                      <div className="col-span-4">
                        <div>६. (ख) गर्भपतनको मिति के हो ?</div>
                        <div className="font-semibold ml-5">
                          {revivedPolicyDetail?.proposerMedical?.dateOfAbortion
                            ? format(
                                new Date(
                                  revivedPolicyDetail?.proposerMedical?.dateOfAbortion
                                ),
                                "yyyy-MM-dd"
                              )
                            : ""}
                        </div>
                      </div>
                    )}

                    <div className="col-span-4">
                      <div>६. (ग) के तपाईका छोराछोरी छन् ?</div>
                      <div className="font-semibold ml-5">
                        {revivedPolicyDetail?.proposerMedical?.hasChildren ===
                        "True"
                          ? "छ"
                          : "छैन"}
                      </div>
                    </div>

                    {revivedPolicyDetail?.proposerMedical?.hasChildren ===
                      "True" && (
                      <>
                        <div className="col-span-4">
                          <div> ६. (ग) अन्तिम प्रसूतिको तरिका के थियो ?</div>
                          <div className="font-semibold ml-5">
                            {revivedPolicyDetail?.proposerMedical?.deliveryType}
                          </div>
                        </div>
                        <div className="col-span-4">
                          <div> ६. (ग) अन्तिम प्रसूति भएको मिति के हो ?</div>
                          <div className="font-semibold ml-5">
                            {revivedPolicyDetail?.proposerMedical
                              ?.dateOfPregnancy
                              ? format(
                                  new Date(
                                    revivedPolicyDetail?.proposerMedical?.dateOfPregnancy
                                  ),
                                  "yyyy-MM-dd"
                                )
                              : ""}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </>
        )}
        <div className="flex gap-2 my-3">
          <FontAwesomeIcon icon={faSquareCheck} className="mt-1" />
          <p>
            म सच्चा हृदयले उद्घोषण गर्दछु कि मैले यस फाराममा उल्लेखित सम्पूर्ण
            प्रश्नहरूको उत्तर सत्य, स्पष्ट तथा पूर्णरूपमा दिएको छु, र जीवन बीमा
            सम्बन्धी जोखिम मूल्याङ्कनका लागि आवश्यक कुनै पनि तथ्य वा परिस्थिति
            लुकाएको वा दबाएको छैन। प्रस्तुत स्वास्थ्य विवरण मेरो / बीमा चाहने
            व्यक्तिको जीवन बीमा पूर्नजागरणको आधार हुनेछ । यदि यस फाराममा
            उल्लेखित कुनै विवरण असत्य, अपूर्ण वा भ्रामक पाइएमा बीमालेखमा
            उल्लिखित सम्पूर्ण शर्त तथा प्रावधानहरू बमोजिम कम्पनीले आवश्यक निर्णय
            गर्न सक्नेछ भन्ने कुरा म पूर्णतः स्वीकार गर्दछु।
          </p>
        </div>

        <p className="text-red-500">
          ** This is digitally generated policy revival form, hence bears no
          signature.**
        </p>
      </div>
    </>
  );
};

export default RevivedPolicyDetail;
